import { useNavigate, useLocation } from "react-router-dom";
// import { axiosInstance } from "../api/axios";
import useAuth from "./useContexts";
import { clearSession } from "../common/utils/tokenStorage";

const useLogout = () => {
  const { setAuth } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  const logout = async () => {
    try {
      // Clears both stores, and the companyData copy this previously left behind.
      clearSession();
      navigate("/login", { state: { from: location }, replace: true });
      setAuth({});
      // const response = await axiosInstance("/logout");
      // if (response.data.success) {
      //   setAuth({});
      //   navigate("/login", { state: { from: location }, replace: true });
      // }
    } catch (err: any) {
      console.log(err);
    }
  };

  return logout;
};

export default useLogout;
